import { useStateWithCallback } from 'unitx-ui/hooks';
import { useEffect, useMemo, useRef } from 'react';
import { mutableGraphMap } from "./useGraph";
import { useElement } from "./useElement";
export default (props => {
  const {
    id,
    source,
    target,
    onPositionChange,
    graphID,
    config
  } = props;
  const {
    cy
  } = mutableGraphMap[graphID];
  const [, setState] = useStateWithCallback({}, () => {});
  const contextRef = useRef({
    render: callback => {
      setState({}, callback);
    },
    element: null
  });
  contextRef.current.element = useMemo(() => {
    const {
      current: {
        element
      }
    } = contextRef;

    if (element) {
      cy.remove(element);
    }

    return cy.add({
      data: {
        id,
        source,
        target,
        onPositionChange: () => {
          onPositionChange === null || onPositionChange === void 0 ? void 0 : onPositionChange({
            // @ts-ignore
            element: contextRef.current.element,
            context: contextRef.current
          });
        }
      },
      group: 'edges'
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [cy, id, source, target]);
  const {
    current: {
      element
    }
  } = contextRef;
  useEffect(() => {
    element.data('onPositionChange', () => {
      onPositionChange === null || onPositionChange === void 0 ? void 0 : onPositionChange({
        element,
        context: contextRef.current
      });
    });
  }, [onPositionChange]);
  useEffect(() => () => {
    cy.remove(element);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [cy, id, source, target]);
  useElement({
    contextRef,
    cy,
    element,
    config
  });
  return {
    element,
    context: contextRef.current
  };
});